import { section } from "@/neon";

import carousel from "@/components/carousel";

const selectors = {
  carouselContainer: ".testimonials__slides",
};

section("testimonials", {
  onLoad() {
    this.carouselContainer = this.container.querySelector(
      selectors.carouselContainer
    );

    this.carousel = carousel(this.container);
  },

  onBlockSelect({ target: slide }) {
    this.carousel.goToSlide(slide.dataset.index);
  },

  onUnload() {
    this.carousel.unload();
  },
});
